// How a kid looks on the parent pages, the same as the iPhone app (PTheme / KidStatus in ParentHomeView.swift).

export const C = {
  bg: "#F5F4F0", ink: "#2C342A", muted: "#707A6E", line: "#E4E2DC", soft: "#F0EFEB",
  moss: "#5C7A4F", mossL: "#E6EDE1", sun: "#F2B544", sunL: "#FDF1D8", sunInk: "#A87414",
  coral: "#C06E52", coralL: "#F6E3DC", sky: "#4D9ED9", skyL: "#E1EFF9", skyInk: "#2D79B0",
  grape: "#8C6CD0", grapeL: "#EEE8FA", grapeInk: "#6A4BB0",
};

/** "9:00 pm" today, "9:00 pm Sat" another day. */
export function whenText(iso) {
  if (!iso) return "";
  const d = new Date(iso), now = new Date();
  const t = d.toLocaleTimeString([], { hour: "numeric", minute: "2-digit" }).toLowerCase();
  return d.toDateString() === now.toDateString() ? t : `${t} ${d.toLocaleDateString([], { weekday: "short" })}`;
}

// Each kid's colour by their place in the family (the kid app's Whose turn uses the same order).
export const KID_COLOURS = ["#AD8CD6", "#4D9ED9", "#E6A23C", "#6BB08F", "#C06E52", "#8F8FCC"];

export function kidColour(kidId, kids) {
  const i = Math.max(0, (kids || []).findIndex((k) => k.id === kidId));
  return KID_COLOURS[i % KID_COLOURS.length];
}

/** "1h 05m", "40m", "2h". */
export function hm(seconds) {
  const s = Math.max(0, Math.floor(seconds || 0));
  const h = Math.floor(s / 3600), m = Math.floor((s % 3600) / 60);
  if (h === 0) return `${m}m`;
  return m === 0 ? `${h}h` : `${h}h ${String(m).padStart(2, "0")}m`;
}

/** "30 min", "1 hour", "2 hours". */
export function minLabel(m) {
  return m >= 60 && m % 60 === 0 ? `${m / 60} hour${m >= 120 ? "s" : ""}` : `${m} min`;
}

const REASONS = {
  schedule: "Bedtime",
  outside_window: "Outside allowed hours",
  quota_exhausted: "Out of time",
  tasks_pending: "Tasks to finish",
  agreement_unsigned: "Agreement not signed",
  agreement_broken: "Agreement broken",
  event: "Getting ready",
  app_deleted: "Yoda deleted from phone",
};

/** The status pill text and colours: { text, fg, bg, bar }. */
export function kidStatus(kid) {
  const p = kid?.policy || {};
  if (kid?.paused) return { text: "Paused by you", fg: C.sunInk, bg: C.sunL, bar: C.sun };
  if (p.unlimited_active && !p.shielded) {
    return { text: `Unlimited until ${whenText(p.unlimited_until)}`, fg: C.grapeInk, bg: C.grapeL, bar: C.grape };
  }
  if (p.override_active) {
    return { text: `Extra time · ${hm(p.override_remaining_seconds)} left`, fg: C.skyInk, bg: C.skyL, bar: C.sky };
  }
  if (p.shielded) return { text: REASONS[p.reason] || "Blocked", fg: C.coral, bg: C.coralL, bar: C.coral };
  return { text: "On", fg: C.moss, bg: C.mossL, bar: C.moss };
}

export function KidAvatar({ name, colour, size = 46 }) {
  return (
    <div className="flex flex-none items-center justify-center rounded-full font-bold text-white"
         style={{ width: size, height: size, background: colour, fontSize: size * 0.42 }}>
      {(name || "?").slice(0, 1).toUpperCase()}
    </div>
  );
}

export function StatusPill({ status }) {
  return (
    <span className="pill" style={{ color: status.fg, background: status.bg }}>
      <i className="dot" /> {status.text}
    </span>
  );
}
